import { fluidType } from 'Shared/common/FluidType';
import { colourRule } from 'Shared/model/settingColour';
import { FluidLength, Palette, TextStyle } from 'Shared/model/venueSettings';


/*
	A fontSize off a text style is either a plain css string ('40px', '2em') or the fluid object the
	Amount control writes; the object becomes a clamp() the same way
	Shared/frontend/widgets/Amount.amount() does it.
*/
export function resolveFontSize(fontSize:string|FluidLength): string
{
	return typeof fontSize=='string' ? fontSize :
		fluidType('px',fontSize.pageMin,fontSize.pageMax,fontSize.minValue,fontSize.maxValue);
}


/*
	Turns a stored text style into the css BaseSettings.text() merges onto standardText(). Only the
	fields the venue actually set contribute - an unset field spreads {}, and merge() then keeps
	standardText()'s value, exactly as leaving the field out of a venue's text() override used to.
*/
export function textStyleRule(style:TextStyle,palette:Palette): object
{
	return {
		...colourRule('color',style.color,palette),
		...(style.fontFamily    !=undefined ? {fontFamily: style.fontFamily} : {}),
		...(style.fontWeight    !=undefined ? {fontWeight: style.fontWeight} : {}),
		...(style.fontSize      !=undefined ? {fontSize: resolveFontSize(style.fontSize)} : {}),
		...(style.textTransform !=undefined && style.textTransform!='' ? {textTransform: style.textTransform} : {}),
		...(style.lineHeight    !=undefined ? {lineHeight: style.lineHeight} : {}),
		...(style.letterSpacing !=undefined ? {letterSpacing: style.letterSpacing} : {}),
		...(style.textAlign     !=undefined && style.textAlign!='' ? {textAlign: style.textAlign} : {}),
		...(style.margin        !=undefined ? {margin: style.margin} : {}),
	};
}
